import './Top.css';
import logo from '../image/logo.svg'
import {Component} from "react";
import {showToast} from "../utils/methods";


class top extends Component {
    pressDownload() {
        // window.scrollTo(0, 0);
        window.location.href = '/'; //relative to domain
    }

    onMainMenuClicked(type) {
        this.setState({
            activeMenu: type
        })
        let ele
        if (type === MainMenuType.Purchase) {
            ele = document.getElementById("purchase");
            ele.scrollIntoView({behavior: 'smooth'})
        } else if (type === MainMenuType.ContactUs) {
            ele = document.getElementById("contactus'");
            ele.scrollIntoView({behavior: 'smooth'})
        }
    }

    onContactUs () {
        window.location.href = '/contactUs'; //relative to domain
    }

    showAboutUsInfo() {
        // window.open('aboutUs',)
        window.location.href = '/aboutUs'; //relative to domain
    }

    render() {
        return (
            <div className="about-us-top">
                <div className='about-us-top-left'>
                    <img className='about-us-top-logo' alt='error-img' src={logo}/>
                </div>
                <div className="about-us-top-middle">
                    <div className="about-us-top-middle-words">Nebular Antivirus</div>
                    <div className="about-us-top-middle-words-words">Don't worry Be safe online</div>
                </div>
                <div className='about-us-top-right'>
                    <button className='about-us-top-button' onClick={this.pressDownload.bind(this)}>Home</button>
                    <button className='about-us-top-button' onClick={this.onMainMenuClicked.bind(this, MainMenuType.Purchase)}>Purchase</button>
                    <button className='about-us-top-button' onClick={this.showAboutUsInfo.bind(this)}>About us</button>
                    <button className='about-us-top-button' onClick={this.onContactUs.bind(this)}>Contact us</button>
                </div>
            </div>
        );
    }
}

const MainMenuType = {
    Purchase: 'PURCHASE',
    ContactUs: 'CONTACTUS',
};

export default top